document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.blog-articles');
  const loadMoreButton = document.querySelector('.load-more-button');
  const scrollLoadingIndicator = document.querySelector('.scroll-loading-indicator');
  let currentPage = 1;
  let isLoading = false;
  let hasMorePages = true;
  let isInfiniteScrollEnabled = false;

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', () => {
      loadMore('button');
      enableInfiniteScroll();
      loadMoreButton.style.display = 'none';
    });
  }

  async function loadMore(trigger = 'scroll') {
    if (isLoading || !hasMorePages) return;

    isLoading = true;

    scrollLoadingIndicator.classList.add('visible');

    try {
      const nextPage = currentPage + 1;
      const response = await fetch(`${window.location.pathname}?page=${nextPage}`);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const newArticles = doc.querySelectorAll('.blog-articles__article');

      if (newArticles.length > 0) {
        newArticles.forEach(article => {
          container.appendChild(article.cloneNode(true));
        });
        currentPage = nextPage;
      } else {
        hasMorePages = false;
      }
    } catch (error) {
      console.error('Error loading more articles:', error);
    } finally {
      isLoading = false;
      if (trigger === 'button') {
        loadMoreButton.classList.remove('loading');
      } else {
        scrollLoadingIndicator.classList.remove('visible');
      }
    }
  }

  function enableInfiniteScroll() {
    if (isInfiniteScrollEnabled) return;

    isInfiniteScrollEnabled = true;
    const options = {
      root: null,
      rootMargin: '100px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && hasMorePages && !isLoading) {
          loadMore('scroll');
        }
      });
    }, options);

    function observeLastArticle() {
      const articles = document.querySelectorAll('.blog-articles__article');
      if (articles.length > 0) {
        observer.observe(articles[articles.length - 1]);
      }
    }

    observeLastArticle();

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          observer.disconnect();
          observeLastArticle();
        }
      });
    });

    mutationObserver.observe(container, {
      childList: true
    });
  }
});
